import React from 'react';

import Entry from './entry';
import Form from './form';
import Icon from '@mui/icons-material/SpeakerNotes';

export default class Resources {
  static Entry = Entry;
  static Form = Form;
  static Icon = Icon;
  static MenuLabel = (
    <>
      <b>Form</b>topia
    </>
  );
}
